
<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @clear-form-errors="clearFormErrors"
    @new-open-action="loadServerEntry"
    ref="baseNew"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :item="item"
        :modelNameSingular="modelNameSingular"
      />
    </template>
    
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from './form.vue';
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: false,
      pageLoading: false,
      entry: null,
      formErrors: [],
    };
  },
  props: {
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    extraData: {
      type: Object,
      default: null,
    },
    item: {
      type: Object,
      default: null,
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  created() {
    // this.loadServerEntries();
    // console.log("item goal new", this.extraData);
    // this.entry = new Object();
  },
  methods: {
    loadServerEntry: function() {
      this.entry = new Object();
    //   this.error = null;
    //   this.loading = true;
    //   this.$apollo
    //     .query({
    //       query: LOAD_NEW_GOAL_QUERY,
    //       fetchPolicy: "no-cache"
    //     })
    //     .then(response => {
    //       this.entry = response.data.accountContext.goal;
    //       // response.data.goal = this.extraData.goal;
    //       this.extraData = response.data;
    //       // console.log("after load item", this.extraData);
    //     })
    //     .catch(response => console.log(response))
    //     .finally(() => (this.loading = false));

    },

    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.$refs.baseNew.closeDialog();
        this.$emit("entry-created", this.entry);
        this.resetForm();
        return true;
      } else {
        return false;
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_GOAL_QUERY = gql `
  {
    accountContext{
      goal {
        id
        validations
      }
      allHarvests {
        id
        name
      }
      allMyCustomers{
        id
        name
      }
    } 
  }
`;

const CREATE_GOAL_MUTATION = gql `
  mutation($input: GoalCreateInputObject!) {
    createGoal(input: $input) {
      goal {  
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

